module.exports = __webpack_public_path__ + "34bc775d/img/SOURCERY_poweredby_web.9819842b.png";